import React from 'react';
import { AirflowDag, AirflowDagDetails } from '../../types';
import { displayValue, formatDateTime } from '../../utils';
import { DetailRow } from '../../detail-row';
import styles from '../../styles.module.scss';

type DetailsTabProps = {
    dag: AirflowDag | null;
    details: AirflowDagDetails | null;
    isLoading: boolean;
};

/*
 * Read-only key/value view of a DAG's full metadata
 */
export function DetailsTab({ dag, details, isLoading }: DetailsTabProps) {
    if (isLoading || !dag) return null;

    return (
        <div className={styles.card}>
            <DetailRow label="DAG ID">{dag.dag_id}</DetailRow>
            <DetailRow label="Display Name">{displayValue(dag.dag_display_name)}</DetailRow>
            <DetailRow label="Description">{displayValue(dag.description)}</DetailRow>
            <DetailRow label="File Location">{displayValue(dag.fileloc)}</DetailRow>
            <DetailRow label="Bundle Name">{displayValue(dag.bundle_name)}</DetailRow>
            <DetailRow label="Owners">{dag.owners?.join(', ') || '—'}</DetailRow>
            <DetailRow label="Tags">{dag.tags?.map((tag) => tag.name).join(', ') || '—'}</DetailRow>
            <DetailRow label="Is Paused">{displayValue(dag.is_paused)}</DetailRow>
            <DetailRow label="Has Import Errors">{displayValue(dag.has_import_errors)}</DetailRow>
            <DetailRow label="Max Active Runs">{displayValue(details?.max_active_runs)}</DetailRow>
            <DetailRow label="Max Active Tasks">{displayValue(details?.max_active_tasks)}</DetailRow>
            <DetailRow label="Catchup">{displayValue(details?.catchup)}</DetailRow>
            <DetailRow label="Start Date">{formatDateTime(details?.start_date)}</DetailRow>
            <DetailRow label="End Date">{formatDateTime(details?.end_date)}</DetailRow>
            <DetailRow label="Timezone">{displayValue(details?.timezone)}</DetailRow>
            <DetailRow label="Last Parsed">{formatDateTime(details?.last_parsed ?? details?.last_parsed_time)}</DetailRow>
        </div>
    );
}
